import React, { useEffect } from "react";
import "./PolicyPage.css";

const PolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Chính sách dữ liệu người dùng | XEVF.VN";
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>CHÍNH SÁCH DỮ LIỆU NGƯỜI DÙNG</h1>
        <p className="policy-meta">Áp dụng cho website: xevf.vn<br/>Cập nhật lần cuối: 15/07/2026</p>
        
        <div className="policy-content">
          <h2>1. Mục đích của chính sách</h2>
          <p>Chính sách dữ liệu người dùng này được ban hành nhằm minh bạch về việc thu thập, xử lý, sử dụng và bảo vệ dữ liệu cá nhân của người dùng khi truy cập và sử dụng website xevf.vn, đồng thời tuân thủ quy định của pháp luật Việt Nam, bao gồm nhưng không giới hạn ở:</p>
          <ul>
            <li>Nghị định số 13/2023/NĐ-CP về bảo vệ dữ liệu cá nhân;</li>
            <li>Luật An ninh mạng;</li>
            <li>Luật Bảo vệ quyền lợi người tiêu dùng và các văn bản pháp luật có liên quan.</li>
          </ul>

          <h2>2. Thông tin về chủ sở hữu website</h2>
          <p>Website xevf.vn thuộc sở hữu và quản lý bởi cá nhân.</p>
          <p>Thông tin liên hệ:</p>
          <ul>
            <li>Email: thanhtrung86nd@gmail.com</li>
            <li>Điện thoại: 0984472080</li>
          </ul>

          <h2>3. Phạm vi hoạt động của website</h2>
          <p>Website xevf.vn được xây dựng nhằm mục đích cung cấp thông tin về các dòng xe VinFast, bao gồm:</p>
          <ul>
            <li>Giới thiệu thông tin xe;</li>
            <li>So sánh thông số kỹ thuật giữa các mẫu xe;</li>
            <li>Cập nhật bảng giá tham khảo;</li>
            <li>Tiếp nhận yêu cầu liên hệ từ người dùng.</li>
          </ul>
          <p>Website không cung cấp chức năng:</p>
          <ul>
            <li>Đăng ký tài khoản;</li>
            <li>Đăng nhập người dùng;</li>
            <li>Mạng xã hội hoặc diễn đàn;</li>
            <li>Chat trực tuyến;</li>
            <li>Đặt cọc hoặc thanh toán trực tiếp.</li>
          </ul>
          <p>Khi người dùng lựa chọn đặt cọc xe, website sẽ chuyển hướng sang website chính thức của VinFast để thực hiện giao dịch. Việc xử lý dữ liệu tại website của VinFast sẽ tuân theo chính sách riêng của đơn vị đó.</p>

          <h2>4. Dữ liệu được thu thập</h2>
          <h3>4.1 Khi người dùng chỉ truy cập website</h3>
          <p>Khi người dùng truy cập để:</p>
          <ul>
            <li>xem thông tin xe;</li>
            <li>xem bảng giá;</li>
            <li>so sánh các mẫu xe;</li>
          </ul>
          <p>website không yêu cầu đăng ký tài khoản, không yêu cầu đăng nhập, không thu thập dữ liệu cá nhân và không theo dõi hành vi người dùng.</p>
          <p>Website không sử dụng các công cụ phân tích hoặc quảng cáo nhằm thu thập dữ liệu người dùng.</p>

          <h3>4.2 Khi người dùng gửi biểu mẫu liên hệ</h3>
          <p>Khi người dùng chủ động gửi biểu mẫu liên hệ trên website, xevf.vn chỉ xử lý các thông tin mà người dùng tự nguyện cung cấp, bao gồm:</p>
          <ul>
            <li>Số điện thoại;</li>
            <li>Địa chỉ email;</li>
            <li>Nội dung liên hệ.</li>
          </ul>
          <p>Các thông tin này được sử dụng duy nhất nhằm:</p>
          <ul>
            <li>Tiếp nhận yêu cầu của người dùng;</li>
            <li>Phản hồi các câu hỏi hoặc thắc mắc;</li>
            <li>Hỗ trợ người dùng theo đúng nội dung đã gửi.</li>
          </ul>
          <p>Website không yêu cầu người dùng cung cấp họ và tên, không thu thập các thông tin cá nhân ngoài những nội dung nêu trên và không sử dụng các thông tin này cho mục đích quảng cáo, tiếp thị hoặc bất kỳ mục đích nào khác khi chưa có sự đồng ý của người dùng.</p>

          <h2>5. Mục đích xử lý dữ liệu</h2>
          <p>Thông tin do người dùng tự nguyện cung cấp chỉ được sử dụng cho các mục đích sau:</p>
          <ul>
            <li>trả lời yêu cầu liên hệ;</li>
            <li>hỗ trợ người dùng;</li>
            <li>giải đáp các vấn đề liên quan đến nội dung website.</li>
          </ul>
          <p>Website không sử dụng dữ liệu này cho mục đích quảng cáo hoặc tiếp thị nếu không có sự đồng ý của người dùng.</p>

          <h2>6. Website không sử dụng công cụ theo dõi</h2>
          <p>Website xevf.vn hiện không sử dụng:</p>
          <ul>
            <li>Google Analytics;</li>
            <li>Facebook Pixel;</li>
            <li>Google Tag Manager phục vụ theo dõi người dùng;</li>
            <li>Microsoft Clarity;</li>
            <li>Hotjar;</li>
            <li>các công cụ phân tích hành vi tương tự;</li>
            <li>các nền tảng quảng cáo thu thập dữ liệu người dùng.</li>
          </ul>
          <p>Website cũng không xây dựng hồ sơ người dùng hoặc phân tích hành vi truy cập.</p>

          <h2>7. Cookie</h2>
          <p>Website chỉ sử dụng cookie kỹ thuật cần thiết để đảm bảo hoạt động ổn định của website.</p>
          <p>Các cookie này:</p>
          <ul>
            <li>không dùng để theo dõi người dùng;</li>
            <li>không phục vụ quảng cáo;</li>
            <li>không phân tích hành vi;</li>
            <li>không xây dựng hồ sơ cá nhân.</li>
          </ul>
          <p>Người dùng có thể tự quản lý hoặc xóa cookie thông qua cài đặt của trình duyệt.</p>

          <h2>8. Chia sẻ dữ liệu</h2>
          <p>Website không bán, không trao đổi, không cho thuê và không chia sẻ dữ liệu cá nhân của người dùng cho bất kỳ tổ chức hoặc cá nhân nào, ngoại trừ các trường hợp:</p>
          <ul>
            <li>có sự đồng ý của người dùng;</li>
            <li>theo yêu cầu của cơ quan nhà nước có thẩm quyền theo quy định của pháp luật.</li>
          </ul>

          <h2>9. Lưu trữ dữ liệu</h2>
          <p>Đối với người chỉ truy cập website, xevf.vn không lưu trữ dữ liệu cá nhân.</p>
          <p>Đối với thông tin người dùng tự nguyện gửi qua biểu mẫu liên hệ, dữ liệu chỉ được lưu giữ trong phạm vi cần thiết để xử lý và phản hồi yêu cầu của người dùng, sau đó sẽ được xóa hoặc ngừng sử dụng khi không còn cần thiết, trừ trường hợp pháp luật quy định khác.</p>
          <p>Máy chủ của website được đặt tại Việt Nam.</p>

          <h2>10. Bảo mật dữ liệu</h2>
          <p>Chủ sở hữu website áp dụng các biện pháp kỹ thuật và quản lý phù hợp nhằm bảo vệ dữ liệu khỏi:</p>
          <ul>
            <li>truy cập trái phép;</li>
            <li>tiết lộ trái phép;</li>
            <li>thay đổi trái phép;</li>
            <li>mất mát hoặc phá hủy dữ liệu.</li>
          </ul>
          <p>Mặc dù đã áp dụng các biện pháp bảo mật hợp lý, không có hệ thống truyền tải hoặc lưu trữ dữ liệu nào có thể đảm bảo an toàn tuyệt đối.</p>

          <h2>11. Quyền của người dùng</h2>
          <p>Theo quy định của pháp luật Việt Nam, người dùng có quyền:</p>
          <ul>
            <li>được biết việc xử lý dữ liệu cá nhân của mình;</li>
            <li>yêu cầu chỉnh sửa thông tin đã cung cấp;</li>
            <li>yêu cầu xóa dữ liệu trong phạm vi pháp luật cho phép;</li>
            <li>yêu cầu chấm dứt việc xử lý dữ liệu khi có căn cứ phù hợp;</li>
            <li>gửi khiếu nại hoặc phản ánh liên quan đến việc xử lý dữ liệu.</li>
          </ul>
          <p>Mọi yêu cầu có thể được gửi qua:</p>
          <ul>
            <li>Email: thanhtrung86nd@gmail.com</li>
            <li>Điện thoại: 0984472080</li>
          </ul>

          <h2>12. Liên kết đến website bên thứ ba</h2>
          <p>Website có thể chứa liên kết đến website chính thức của VinFast hoặc các website khác.</p>
          <p>Sau khi người dùng rời khỏi xevf.vn, việc thu thập và xử lý dữ liệu sẽ được điều chỉnh bởi chính sách riêng của website mà người dùng truy cập. Chủ sở hữu website xevf.vn không chịu trách nhiệm đối với nội dung hoặc chính sách bảo mật của các website bên thứ ba.</p>

          <h2>13. Thay đổi chính sách</h2>
          <p>Chủ sở hữu website có quyền sửa đổi hoặc cập nhật Chính sách dữ liệu người dùng nhằm phù hợp với sự thay đổi của pháp luật hoặc hoạt động của website.</p>
          <p>Phiên bản mới nhất sẽ được công bố trên website xevf.vn và có hiệu lực kể từ thời điểm được đăng tải.</p>

          <h2>14. Thông tin liên hệ</h2>
          <p>Mọi câu hỏi, góp ý hoặc yêu cầu liên quan đến Chính sách dữ liệu người dùng vui lòng liên hệ:</p>
          <p><strong>Chủ sở hữu website xevf.vn</strong></p>
          <ul>
            <li>Email: thanhtrung86nd@gmail.com</li>
            <li>Điện thoại: 0984472080</li>
          </ul>
          <p>Chủ sở hữu sẽ tiếp nhận và xử lý các yêu cầu trong thời gian hợp lý theo quy định của pháp luật.</p>
        </div>
      </div>
    </div>
  );
};

export default PolicyPage;
